export default "https://assets-v2.scaler.com/packs/files/ug_referral_reward.7a5ad3.webp";